module.exports = __webpack_public_path__ + "static/img/KO.345afe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/pc/KO.png
// module id = HsIx
// module chunks = 1